import { InputSelect } from "../../components/formComponents/inputSelect";
import { InputFecha } from "../../components/formComponents/InputFecha";
import { useMotivosDesvinculacion } from "./useMotivosDesvinculacion";
import ErrorInput from "../../components/ui/ErrorInput";
import { useEffect } from "react";

export const SolicitudDesvinculacion = props => {
  const { motivos, traerMotivos } = useMotivosDesvinculacion();
  const { formik } = props;

  useEffect(() => {
    traerMotivos();
  }, []);

  return (
    <>
      <div>
        <InputFecha formik={formik} label="Fecha de baja colaborador *" id="fecha_inicio_cambio" />
      </div>
      <div>
        <div className="d-flex flex-row justify-content-between">
          <label htmlFor="">Causal de desvinculación *</label>
          {formik.errors.id_clausula_despido !== undefined && formik.touched.id_clausula_despido !== undefined && <ErrorInput touched={formik.touched.id_clausula_despido} error={formik.errors.id_clausula_despido} />}
        </div>
        <InputSelect disabled={!formik.values.fecha_inicio_cambio} label="xxx" arr={motivos} id="id_clausula_despido" llave_texto="nombre" llave_valor="id" formik={formik} />
      </div>
      <div>
        <div className="d-flex flex-row justify-content-between">
          <label htmlFor="">Justificación de la solicitud *</label>
          {formik.values.motivo_desvinculacion?.length ? <span class="badge rounded-pill bg-info text-dark d-flex align-items-center mt-2">{300 - formik.values.motivo_desvinculacion?.length}</span> : ""}
        {formik.errors.motivo_desvinculacion !== undefined && formik.touched.motivo_desvinculacion !== undefined && <ErrorInput touched={formik.touched.motivo_desvinculacion} error={formik.errors.motivo_desvinculacion} />}
        </div>
        <textarea disabled={!formik.values.id_clausula_despido} onChange={formik.handleChange} name="" maxLength={300} className="form-control" id="motivo_desvinculacion">
          {formik.values.motivo_desvinculacion}
        </textarea>
      </div>
    </>
  );
};
